import { z } from "zod";

export function getViewName<
  T extends z.ZodObject<{ view: z.ZodLiteral<string> }>,
>(schema: T): z.infer<T>["view"] {
  // eslint-disable-next-line no-underscore-dangle
  return schema.shape.view._def.value;
}
